import { useBAccountData } from '../../FireBaseApp/AuthProtector';
//import { Chip } from '@mui/material';

export function NameFromPhoneNumber(number) {
    const BAccountData = useBAccountData()
    if (BAccountData.Numbers === undefined || BAccountData.Numbers[number] === undefined) {
        return number
    }
    return BAccountData.Numbers[number]
}